import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import cs from './cs.json';
import en from './en.json';

i18n.use(initReactI18next).init({
  lng: 'cs',
  fallbackLng: 'cs',
  debug: false,
  resources: {
    cs: {
      translation: cs,
    },
    en: {
      translation: en,
    },
  },
});

export default i18n;
